import * as React from 'react';

export const ErrorView: React.SFC<{ errorMessage: any }> = props => {
  const { errorMessage } = props;

  return (
    <div className="error-page-view">
      <div className="header" />
      <div className="container">
        <div className="jumbotron text-center pt-4">
          <h1>
            <span className="fa fa-exclamation-triangle" /> Oops. There appears
            to be a server error.
          </h1>
          <p className="lead">
            The web server is returning the error:{' '}
            <em>
              {errorMessage && errorMessage.message
                ? errorMessage.message
                : 'Unknown'}
            </em>
            <br /> The request url which caused the error is :<br />
            <em>
              <span id="display-domain">
                {' '}
                {errorMessage && errorMessage.request
                  ? errorMessage.request.url
                  : 'Unknown'}
              </span>
            </em>.
          </p>
          <a
            href="javascript:document.location.reload(true);"
            className="btn btn-default btn-lg text-center"
          >
            <span className="green">Try This Page Again</span>
          </a>
        </div>
      </div>
      <div className="container">
        <div className="body-content">
          <div className="row">
            <div className="col-md-6">
              <h2>What happened?</h2>
              <p className="lead">
                This error status implies there is a problem with the web
                server's software, or you may not have permission to access this
                file or page.
              </p>
            </div>
            <div className="col-md-6">
              <h2>What can I do?</h2>
              <p className="lead">If you're a site visitor</p>
              <p>
                {' '}
                Nothing you can do at the moment. If you need immediate
                assistance, please send us an email instead. We apologize for
                any inconvenience.
              </p>
              <p className="lead">If you're the site owner</p>
              <p>
                This error can only be fixed by server admins, please contact
                your website administrator.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/main/ErrorView.tsx